// extracted by mini-css-extract-plugin
export default {"container":"ProjectComponent_container__4vv4P","card":"ProjectComponent_card__k+ZeD","button":"ProjectComponent_button__LxYnv"};